// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkflowStatusTransitionHistoryInner
 */
export interface WorkflowStatusTransitionHistoryInner {
    /**
     * 
     * @type {string}
     * @memberof WorkflowStatusTransitionHistoryInner
     */
    from_stage?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStatusTransitionHistoryInner
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStatusTransitionHistoryInner
     */
    to_stage: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStatusTransitionHistoryInner
     */
    transition_id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStatusTransitionHistoryInner
     */
    transitioned_at: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStatusTransitionHistoryInner
     */
    transitioned_by: string;
}

/**
 * Check if a given object implements the WorkflowStatusTransitionHistoryInner interface.
 */
export function instanceOfWorkflowStatusTransitionHistoryInner(value: object): value is WorkflowStatusTransitionHistoryInner {
    if (!('to_stage' in value) || value['to_stage'] === undefined) return false;
    if (!('transition_id' in value) || value['transition_id'] === undefined) return false;
    if (!('transitioned_at' in value) || value['transitioned_at'] === undefined) return false;
    if (!('transitioned_by' in value) || value['transitioned_by'] === undefined) return false;
    return true;
}

export function WorkflowStatusTransitionHistoryInnerFromJSON(json: any): WorkflowStatusTransitionHistoryInner {
    return WorkflowStatusTransitionHistoryInnerFromJSONTyped(json, false);
}

export function WorkflowStatusTransitionHistoryInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowStatusTransitionHistoryInner {
    if (json == null) {
        return json;
    }
    return {
        
        'from_stage': json['from_stage'] == null ? undefined : json['from_stage'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'to_stage': json['to_stage'],
        'transition_id': json['transition_id'],
        'transitioned_at': json['transitioned_at'],
        'transitioned_by': json['transitioned_by'],
    };
}

export function WorkflowStatusTransitionHistoryInnerToJSON(json: any): WorkflowStatusTransitionHistoryInner {
    return WorkflowStatusTransitionHistoryInnerToJSONTyped(json, false);
}

export function WorkflowStatusTransitionHistoryInnerToJSONTyped(value?: WorkflowStatusTransitionHistoryInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'from_stage': value['from_stage'],
        'reason': value['reason'],
        'to_stage': value['to_stage'],
        'transition_id': value['transition_id'],
        'transitioned_at': value['transitioned_at'],
        'transitioned_by': value['transitioned_by'],
    };
}
